import reduceReducers from "reduce-reducers";

import { SELL_VIA_EX_AGENT_REBATE } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  deploymentNestedArrayReducer,
} from "lib/reducers";
import { deserializeSellViaExAgentRebate as deserializer } from "lib/serializers/sellViaExAgentRebates";

const deploymentReducer = deploymentNestedArrayReducer({
  arrayField: "sell_via_ex_agent_rebates",
  injectField: "billing_settings_id",
  parentIdField: "billingSettingsId",
  getParentId: payload => payload.billing_settings?.id,
  deserializer,
});

const fetch = apiModelOfflineFetchReducer(SELL_VIA_EX_AGENT_REBATE, {
  deserializer,
  clearOnRequest: false,
});

const sellViaExAgentRebatesReducer = reduceReducers(fetch, deploymentReducer);

export default sellViaExAgentRebatesReducer;
